import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [username, setUsername] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is authenticated
    const authStatus = localStorage.getItem('isAuthenticated') === 'true';
    setIsAuthenticated(authStatus);
    setUsername(localStorage.getItem('username') || '');
  }, [location]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  
  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('username');
    setIsAuthenticated(false);
    navigate('/login');
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="container navbar-container">
        <Link to="/" className="navbar-logo">
          <span className="logo-text">KURO</span>
        </Link>

        <div className="menu-icon" onClick={toggleMenu}>
          <div className={`menu-icon-bar ${menuOpen ? 'open' : ''}`}></div>
          <div className={`menu-icon-bar ${menuOpen ? 'open' : ''}`}></div>
          <div className={`menu-icon-bar ${menuOpen ? 'open' : ''}`}></div>
        </div>

        <ul className={`navbar-menu ${menuOpen ? 'active' : ''}`}>
          <li className="navbar-item">
            <Link 
              to="/" 
              className={`navbar-link ${location.pathname === '/' ? 'active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              Home
            </Link>
          </li>
          <li className="navbar-item">
            <Link 
              to="/rankings" 
              className={`navbar-link ${location.pathname === '/rankings' ? 'active' : ''}`}
              onClick={() => setMenuOpen(false)}
            >
              Rankings
            </Link>
          </li>
          <li className="navbar-item">
            <a 
              href="https://discord.gg/UF4QCTYEsN" 
              className="navbar-link" 
              target="_blank" 
              rel="noopener noreferrer"
              onClick={() => setMenuOpen(false)}
            >
              Discord
            </a>
          </li>
          
          {!isAuthenticated ? (
            <>
              <li className="navbar-item">
                <Link 
                  to="/login" 
                  className={`navbar-link ${location.pathname === '/login' ? 'active' : ''}`}
                  onClick={() => setMenuOpen(false)}
                >
                  Login
                </Link>
              </li>
              <li className="navbar-item register-item">
                <Link 
                  to="/register" 
                  className={`navbar-link register-link ${location.pathname === '/register' ? 'active' : ''}`}
                  onClick={() => setMenuOpen(false)}
                >
                  Register
                </Link>
              </li>
            </>
          ) : (
            <>
              {username && (
                <li className="navbar-item">
                  <span className="welcome-text">Welcome, {username}</span>
                </li>
              )}
              <li className="navbar-item">
                <Link 
                  to="/dashboard" 
                  className={`navbar-link ${location.pathname === '/dashboard' ? 'active' : ''}`}
                  onClick={() => setMenuOpen(false)}
                >
                  Dashboard
                </Link>
              </li>
              <li className="navbar-item">
                <button 
                  className="navbar-link logout-link"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;